<template>
    <div class="page">
        <titlebar :name="name" />
        <div class="list_title">
            <div>创建时间</div>
            <div>更新时间</div>
            <div>单位名称</div>
            <div>操作</div>
        </div>
        <!-- 提现记录表 -->
        <div class="box_index">
            <div
                class="list_index"
                v-for="(item, index) in list"
                :key="index"
            >
                <div>{{ item.create_time }}</div>
                <div>{{ item.update_time }}</div>
                <div>{{ item.name }}</div>
                <div>
                    <template v-if="shop.user_model == 1">
                        <van-icon name="edit" size="3rem" @click="edit(item)" />
                        <van-icon name="delete-o" size="3rem" color="#ee0a24" @click="openDialog(item)" style="margin-left: 6rem" />
                    </template>
                    <template v-else>无权操作</template>
                </div>
            </div>
        </div>
        <van-col span="24">
            <div class="bottom-con" style="padding: 3rem;">
                <van-pagination
                    v-model="page"
                    :total-items="total"
                    :items-per-page="limit"
                    @change="pageChange"
                    force-ellipses
                    mode="simple"
                    style="width: 30%;"
                />
                <van-button color="#1588F5" @click="add" v-if="shop.user_model == 1" icon="add">新增单位</van-button>
            </div>
        </van-col>

        <van-popup v-model="showdet" @close="unit_name = ''">
            <div class="popups">
                <div class="system_title">
                    <div>{{ popTitle }}单位</div>
                    <img src="https://cashier.demo.api.dianzhangbao.com.cn/202106/mdsy/close.png" @click="showdet = false" />
                </div>
                <div class="detail">
                    <input type="text" v-model="unit_name" ref="modalInput" autofocus :maxlength="2" />
                </div>
                 <div class="but" @click="confirmDet">确定</div>
            </div>
        </van-popup>

        <popupOfDialog
            v-if="showDialog"
            :type="dialogType"
            :title="dialogTitle"
            :message="dialogMsg"
            :data="dialogData"
            @closePopDialog="closePopDialog"
            @confirmPopDialog="confirmPopDialog"
        ></popupOfDialog>
    </div>
</template>

<script>
import titlebar from "@/views/component/titlebar";
import { mapGetters } from 'vuex';
import popupOfDialog from "../component/popupOfDialog.vue";
export default {
    name: "ShopCategory",
    components: {titlebar, popupOfDialog},
    async created() {
        this.name = this.$route.query.name; //拿到传过来的标题
        await this.getShopUnit();
    },
    data() {
        return {
            name: '',
            list: [], // 商品单位
            limit: 8,
            page: 1,
            total: 0,
            showdet: false,
            unit_name: '',
            popTitle: '',
            editId: '',
            showDialog: false,
            dialogTitle: "",
            dialogMsg: "",
            dialogType: "",
            dialogData: {},
        }
    },
    computed: {
        ...mapGetters({shop: 'shop'})
    },
    methods: {
        async getShopUnit() {
            let res = await this.$api.getProductsUnit({
                type: 1, // 0全部，1普通，2重量
                limit: this.limit,
                page: this.page
            });
            if (res.code == 1) {
                this.list = res.data.list || [];
                this.total = res.data.count;
            }
        },
        pageChange(e) {
            this.page = e;
            this.getShopUnit();
        },
        add() {
            this.popTitle = '新增';
            this.showdet = true;
        },
        edit(item) {
            this.popTitle = '编辑';
            this.editId = item.id;
            this.unit_name = item.name;
            this.showdet = true;
        },
        confirmPopDialog(data) {
            this.del(data.data);
            this.closePopDialog();
        },
        closePopDialog(data) {
            this.showDialog = false;
        },
        openDialog(item) {
            this.dialogTitle = "提示";
            this.dialogMsg = `是否确认删除？`;
            this.dialogType = '4';
            this.dialogData = item;
            this.showDialog = true;
        },
        async del(item) {
            let res = await this.$api.deleteProductsUnit(item.id);
            if (res.code == 1) {
                this.$toast('删除成功');
                await this.getShopUnit();
            }
        },
        async confirmDet() {
            if (this.unit_name) {
                if (this.unit_name.length > 2) {
                    this.$toast('不能超过2个字符');
                    return;
                }
                if (this.popTitle == '新增') {
                    let res = await this.$api.addProductsUnit({
                        name: this.unit_name,
                    })
                    if (res.code == 1) {
                        this.$toast('新增成功');
                        this.showdet = false;
                        await this.getShopUnit();
                    }
                } else {
                    let res = await this.$api.editProductsUnit(this.editId, {
                        name: this.unit_name
                    })
                    if (res.code == 1) {
                        this.$toast('编辑成功');
                        this.showdet = false;
                        await this.getShopUnit();
                    }
                }
            }
        }
    }
}
</script>

<style lang="less" scoped>
.page {
    height: 100%;
    display: flex;
    flex-direction: column;
}
.bottom-con {
    display: flex;
    justify-content: space-between;
    align-items: center;
    box-shadow: 0 0 0.7rem 0.7rem rgba(229, 229, 229, 0.26);
    background: #fff;
}
// /deep/.van-pagination__item--active {
//     color: #fff !important;
//     background-color: #1588F5 !important;
// }
// /deep/.van-pagination__item {
//     color: #1588F5;
// }
.list_title {
    height: 8rem;
    background: #f8f8f8;
    font-size: 2.6rem;
    font-weight: 400;
    color: #333333;
    display: grid;
    grid-template-columns: repeat(4, 25%);
    align-items: center;
}
.box_index {
    // height: 40rem;
    flex: 1;
    overflow-y: scroll;
}
.box_index::-webkit-scrollbar {
    display: none;
}
.list_index {
    height: 8.5rem;
    font-size: 2.6rem;
    font-weight: 400;
    color: #333333;
    display: grid;
    grid-template-columns: repeat(4, 25%);
    align-items: center;
    border-bottom: 0.1rem solid #e5e5e5;
    background: #fff;
}
.popups {
    width: 102.9rem;
    height: 48.7rem;
    background: #ffffff;
    text-align: -webkit-center;

    .system_title {
        display: flex;
        align-items: center;
        //justify-content: flex-end;
        //margin: 0 4.6rem 3.1rem 4.6rem;
        height: 12.5rem;
        border-bottom: 0.1rem solid #e5e5e5;
        font-size: 3.6rem;
        font-weight: 400;
        color: #333333;
        position: relative;
        >:first-child {
            flex: 1;
        }
        img {
            width: 4.3rem;
            position: absolute;
            right: 4rem;
            // height: 4.3rem;
            // text-align: end;
            //margin-left: 29.4rem;
        }
    }

    .detail {
        margin: 10rem 17.6rem 8.5rem 18rem;
        text-align: left;
        font-size: 2.8rem;
        font-weight: bold;
        color: #333333;
        line-height: 4rem;

        input {
            width: 62.6rem;
            height: 7.1rem;
            background: #f8f8f8;
            border-radius: 0.8rem;
            margin: 0 0 2rem 2rem;
            padding-left: 6.3rem;
            font-size: 2.6rem;
            font-weight: 400;
            color: #666666;
            line-height: 3.7rem;
        }

        .detail_context {
            font-size: 3.6rem;
            color: #fe5600;
        }
    }

    .but {
        width: 27rem;
        height: 7rem;
        background: linear-gradient(270deg, #1588F5 0%, #1588F5 100%);
        font-size: 2.8rem;
        font-weight: 500;
        color: #ffffff;
        line-height: 4rem;
        display: flex;
        justify-content: center;
        align-items: center;
    }
}

.van-button--normal {
    font-size: 2.4rem;
    width: 42rem;
    height: 7rem;
    border-radius: 0.8rem;
}

</style>
